<div class="d-flex align-items-center">
    <!-- ============================================================== -->
    <!-- Location / time / weather info -->
    <!-- ============================================================== -->
    <app-header-info></app-header-info>

    <!-- ============================================================== -->
    <!-- Profile - style you can find in header.scss -->
    <!-- ============================================================== -->
    <button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5">
        <img src="assets/images/user.svg" alt="user" class="profile-pic" />
    </button>
    <mat-menu #profile="matMenu" class="mymegamenu">
        <button mat-menu-item (click)="logout()"><mat-icon>exit_to_app</mat-icon>Salir</button>
        <button mat-menu-item (click)="changePwd()"><mat-icon>vpn_key</mat-icon>Cambiar Contraseña</button>
    </mat-menu>
</div>
